import React from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import * as moment from 'moment';

class CustomChartFooter extends React.Component {
  render() {
    const startDate = moment(new Date(this.props.startDate)).format('DD MMM');
    const endDate = moment(new Date(this.props.endDate)).format('DD MMM');
    const date = moment(new Date(this.props.endDate)).format('YYYY-MM-DD');
    const dateToday = moment(new Date()).format('YYYY-MM-DD');
    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <IconButton aria-label='previous page' onClick={() => this.props.handleBackButtonClick(this.props.viewType)}>
          <KeyboardArrowLeft />
        </IconButton>
        {this.props.viewType === 'daily' ? (
          <span style={{ margin: 15 }}>{endDate}</span>
        ) : (
          <span style={{ margin: 15 }}>
            {startDate}-{endDate}
          </span>
        )}
        <IconButton
          aria-label='next page'
          onClick={() => this.props.handleNextButtonClick(this.props.viewType)}
          disabled={date >= dateToday}
        >
          <KeyboardArrowRight />
        </IconButton>
      </div>
    );
  }
}
export default withStyles({ withTheme: true })(CustomChartFooter);
